<template>
    <az-call-to-action dark
                       v-if="!isLicitacaoPresencial"
                       :active="licitacao.podeAcessar"
                       :outline="!licitacao.podeAcessar"
                       @click="acessarPregao(licitacao)"
                       cssClass="botao-participar"
                       class="no-mobile">
        Participar <v-icon class="mr-0">keyboard_arrow_right</v-icon>
    </az-call-to-action>
</template>
<script>
    import {mapState} from 'vuex'

    export default {
        name: 'LicitacaoFornecedorAcoesParticipar',
        computed: {
            ...mapState(['licitacao']),
            isLicitacaoPresencial() {
                return this.licitacao && this.licitacao.modalidade
                    ? this.licitacao.modalidade.includes('PRESENCIAL')
                    : false
            }
        }
    }
</script>
<style lang="stylus">
.botao-participar
  padding-left 5px !important
  padding-right 0 !important
</style>
